import React from "react";

const Context = React.createContext<{
  maxDepth: number;
  deepestOpenedLevel: number;
  mappedEl: { [key: string]: { isOpen: boolean; depth: number } };
  initialize(key: string, depth: number, state: boolean): void;
  open(key: string, depth: number): void;
  close(key: string, depth: number): void;
  setMappedEl(mappedEl: {
    [key: string]: { isOpen: boolean; depth: number };
  }): void;
}>({
  maxDepth: 0,
  deepestOpenedLevel: 0,
  mappedEl: {},
  initialize() {},
  open() {},
  close() {},
  setMappedEl() {},
});

export { Context };
